import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Skeleton,
  Link,
  IconButton,
  Collapse,
  Paper,
  Grid,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Modal,
  Fade,
  TextField,
  InputAdornment
} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import {
  TextFields,
  Subject,
  RadioButtonChecked,
  CheckBox,
  Email,
  Numbers,
  CalendarToday as CalendarMonth,
  Upload,
  Star,
  Phone,
  TableChart,
  LinearScale,
  Sort,
  AccessTime,
  EventNote,
  Language,
  LocationOn,
  Looks3,
  CompareArrows,
  Image as ImageIcon,
  LinearScale as LinearScaleIcon,
  ImageOutlined,
  InsertChartOutlined as NoDataIllustration,
  KeyboardArrowDown,
  KeyboardArrowUp,
  ExpandMore,
  Close as CloseIcon,
  Search as SearchIcon
} from '@mui/icons-material';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { format } from "date-fns";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { fetchSurveyResponses } from "../../store/surveyResponsesSlice";
import FilePreview from '../FilePreview';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "./Results.css";
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';

const decodeHtmlEntities = (text) => {
  if (!text || typeof text !== 'string') return text;
  
  const entities = {
    '&nbsp;': ' ', 
    '&lt;': '<', 
    '&gt;': '>', 
    '&amp;': '&', 
    '&quot;': '"', 
    '&apos;': "'",
    '&#39;': "'", 
    '&#34;': '"',
    '&#38;': '&',
    '&#60;': '<',
    '&#62;': '>',
    '&#160;': ' '
  };

  // First try the fast method with known entities
  let decoded = text;
  Object.entries(entities).forEach(([entity, char]) => {
    decoded = decoded.replace(new RegExp(entity, 'g'), char);
  });

  // Handle numeric HTML entities
  decoded = decoded.replace(/&#(\d+);/g, (_, numStr) => {
    const num = parseInt(numStr, 10);
    return String.fromCodePoint(num);
  });

  // Handle hexadecimal entities
  decoded = decoded.replace(/&#x([0-9a-f]+);/gi, (_, hexStr) => {
    const num = parseInt(hexStr, 16);
    return String.fromCodePoint
  });

  return decoded;
};

const customStyles = `
.p-datatable .p-paginator {
  background: white !important;
}

.p-datatable .p-paginator .p-paginator-current,
.p-datatable .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
     color: #11998e !important;
    border-color: #11998e !important;
}

.p-paginator .p-paginator-pages .p-paginator-page:focus {
  box-shadow: 0 0 0 2px rgba(17, 153, 142, 0.2) !important;
}

.p-paginator .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-last:not(.p-disabled):not(.p-highlight):hover,
.p-paginator .p-paginator-pages .p-paginator-page:not(.p-highlight):hover {
  background-color: rgba(17, 153, 142, 0.1) !important;
  color: #11998e !important;
  border-color: transparent !important;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):hover {
  background-color: rgba(17, 153, 142, 0.1) !important;
  color: #11998e !important;
}

.p-dropdown:not(.p-disabled):hover {
  border-color: #11998e !important;
}

.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {
  color: #11998e !important;
}

.p-dropdown:not(.p-disabled).p-focus {
  border-color: #11998e !important;
  box-shadow: 0 0 0 2px rgba(17, 153, 142, 0.2) !important;
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  background-color: rgba(17, 153, 142, 0.1) !important;
  color: #11998e !important;
}

.p-dropdown .p-dropdown-clear-icon:hover {
  color: #11998e !important;
}

.p-button.p-component:not(.p-disabled):hover {
  background-color: rgba(17, 153, 142, 0.9) !important;
  border-color: #11998e !important;
}

.file-preview-cell {
  padding: 0.5rem;
}

.file-preview-cell img {
  transition: transform 0.2s;
}

.file-preview-cell img:hover {
  transform: scale(1.1);
}

.file-preview-cell a {
  text-decoration: none;
  color: #11998e;
}

.file-preview-cell a:hover {
  text-decoration: underline;
}

  // Add new styles for expandable rows
  .expanded-row-details {
    padding: 16px;
    background-color: #f8f9fa;
    border-radius: 4px;
    margin: 8px 0;
    box-shadow: inset 0 3px 6px rgba(0,0,0,0.05);
  }

  .expanded-row-question {
    font-weight: 500;
    color: #11998e;
    margin-bottom: 4px;
  }

  .expanded-row-answer {
    margin-bottom: 16px;
    padding-left: 16px;
    border-left: 3px solid rgba(17, 153, 142, 0.3);
  }
  
  .row-expander {
    width: 36px !important;
    text-align: center !important;
    cursor: pointer !important;
  }

  .row-expander-button {
    transition: transform 0.2s;
  }
  
  .row-expander-button.expanded {
    transform: rotate(180deg);
  }

  .zoom-button {
    color: #358c7c;
    cursor: pointer;
    transition: transform 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .zoom-button:hover {
    transform: scale(1.2);
    color: #11998e;
  }
  
  .response-detail-modal {
    background-color: #fff;
    border-radius: 8px;
    padding: 0;
    overflow: hidden;
  }
  
  .response-detail-header {
    background-color: rgba(53, 140, 124, 0.08);
    padding: 16px 20px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  
  .response-detail-content {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;
  }
  
  .response-detail-question {
    border-bottom: 1px solid #f0f0f0;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }
  
  .response-detail-question:last-child {
    border-bottom: none;
  }
`;

const Results = () => {
  const dispatch = useDispatch();
  const { 
    currentSurveyId: surveyId,
    responses: apiResponses,
    questions,
    loading: { responses: loading },
    error: { responses: error }
  } = useSelector(state => state.surveyResponses);
  
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [expandedRows, setExpandedRows] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);
  const [expandedAnswers, setExpandedAnswers] = useState({});

  useEffect(() => {
    if (apiResponses && questions && apiResponses.length > 0) {
      transformData();
    }
  }, [apiResponses, questions]);

  const transformData = () => {
    try {
      // Create columns configuration with decoded titles
      const tableColumns = [
        {
          data: "rowNumber",
          title: "No.",
          readOnly: true,
          width: 50,
          type: "text",
        },
        {
          data: "created_at",
          title: "Submitted At",
          readOnly: true,
          width: 150,
          type: "datetime",
        },
        {
          data: "respondent_email",
          title: "Respondent",
          readOnly: true,
          width: 200,
          type: "text",
        },
        ...questions.map((question) => ({
          data: question.id,
          title: decodeHtmlEntities(question.question_text),
          readOnly: true,
          width: 200,
          wordWrap: true,
          type: question.question_type,
        })),
      ];

      // Transform response data for table
      const transformedData = apiResponses.map((response, index) => {
        const rowData = {
          rowNumber: index + 1,
          created_at: format(
            new Date(response.created_at),
            "MMM d, yyyy HH:mm"
          ),
          respondent_email: response.respondent_email,
        };

        // Add answers for each question with proper formatting and decoding
        response.responses.forEach((answer) => {
          let formattedAnswer = answer.answer;
          const questionData = questions.find(
            (q) => q.id === answer.questionId
          );
          const questionType = questionData?.question_type?.toLowerCase();

          switch (questionType) {
            case "short-answer":
            case "text":
              formattedAnswer = decodeHtmlEntities(answer.answer) || "-";
              break;

            case "long-answer":
              formattedAnswer = decodeHtmlEntities(answer.answer) || "-";
              break;

            case "multiple-choice":
              formattedAnswer = decodeHtmlEntities(answer.answer) || "-";
              break;

            case "checkboxes":
              try {
                const checked = Array.isArray(answer.answer)
                  ? answer.answer
                  : JSON.parse(answer.answer);
                formattedAnswer = checked.map(item => decodeHtmlEntities(item)).join(", ") || "-";
              } catch {
                formattedAnswer = "-";
              }
              break;

            case "email":
            case "number":
            case "phone":
              formattedAnswer = decodeHtmlEntities(answer.answer) || "-";
              break;

            case "website":
              formattedAnswer = decodeHtmlEntities(answer.answer) || "No website provided";
              break;

            case "matrix":
              try {
                const matrixData =
                  typeof answer.answer === "string"
                    ? JSON.parse(answer.answer)
                    : answer.answer;
                formattedAnswer =
                  Object.entries(matrixData)
                    .map(([key, value]) => `Q${parseInt(key) + 1}: ${decodeHtmlEntities(value)}/5`)
                    .join(" | ") || "-";
              } catch {
                formattedAnswer = "-";
              }
              break;

            case "ranking":
              try {
                const rankData =
                  typeof answer.answer === "string"
                    ? JSON.parse(answer.answer)
                    : answer.answer;
                formattedAnswer =
                  rankData?.undefined?.map(item => decodeHtmlEntities(item)).join(" > ") || "-";
              } catch {
                formattedAnswer = "Invalid ranking";
              }
              break;

            case "location":
            case "address":
              try {
                const locationData = typeof answer.answer === "string" 
                  ? JSON.parse(answer.answer)
                  : answer.answer;
                
                if (!locationData || typeof locationData !== 'object') {
                  formattedAnswer = "-";
                } else {
                  // Clean and validate each field
                  const cleanStreet = locationData.street?.trim();
                  const cleanCity = locationData.city?.trim();
                  const cleanState = locationData.state?.trim();
                  const cleanZip = locationData.zip?.trim();
                  const cleanCountry = locationData.country?.trim();

                  // Only add non-empty values
                  const addressParts = [];
                  if (cleanStreet) addressParts.push(decodeHtmlEntities(cleanStreet));
                  if (cleanCity) addressParts.push(decodeHtmlEntities(cleanCity));
                  if (cleanState) addressParts.push(decodeHtmlEntities(cleanState));
                  if (cleanZip) addressParts.push(decodeHtmlEntities(cleanZip));
                  if (cleanCountry) addressParts.push(decodeHtmlEntities(cleanCountry));
                  
                  formattedAnswer = addressParts.length > 0 ? addressParts.join(", ") : "-";
                }
              } catch (error) {
                console.error("Error parsing location/address:", error);
                formattedAnswer = "-";
              }
              break;

            default:
              formattedAnswer = decodeHtmlEntities(answer.answer) || "Not specified";
          }

          rowData[answer.questionId] = formattedAnswer;
        });

        return rowData;
      });

      setColumns(tableColumns);
      const paddedData = [...transformedData];
      while (paddedData.length < 10) {
        paddedData.push({}); // push empty rows
      }

      setTableData(paddedData);
    } catch (err) {
      console.error("Error transforming data:", err);
    }
  };

  // Add new function to toggle expanded row
  const toggleRowExpand = (rowId) => {
    setExpandedRows(prev => ({
      ...prev,
      [rowId]: !prev[rowId]
    }));
  };

  // Handle opening the modal with response data
  const handleOpenModal = (rowData) => {
    setSelectedResponse(rowData);
    setModalOpen(true);
  };

  // Handle closing the modal
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // Replace the existing renderExpandedRow function with this implementation
  const renderExpandedRow = (rowData) => {
    return (
      <div className="expanded-row-details">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          mb: 3 
        }}>
          <Typography variant="h6" sx={{ color: '#11998e', fontSize: '1rem' }}>
            Response Details
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Submitted: {rowData.created_at}
          </Typography>
        </Box>
        
        <Grid container spacing={2}>
          {questions.map((question) => {
            const answer = rowData[question.id] || '-';
            
            return (
              <Grid item xs={12} sm={6} md={4} key={question.id}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 2,
                    height: '100%',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'flex-start', 
                    gap: 1, 
                    pb: 1, 
                    borderBottom: '1px solid', 
                    borderColor: 'divider',
                    mb: 1.5
                  }}>
                    {getQuestionIcon(question.question_type)}
                    <Typography 
                      variant="subtitle2" 
                      sx={{ 
                        fontWeight: 500,
                        color: '#11998e',
                        fontSize: '0.875rem',
                        lineHeight: 1.4,
                        flex: 1
                      }}
                    >
                      {decodeHtmlEntities(question.question_text)}
                    </Typography>
                  </Box>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      whiteSpace: 'pre-wrap', 
                      wordBreak: 'break-word',
                      color: 'text.primary', 
                      px: 0.5
                    }}
                  >
                    {answer}
                  </Typography>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </div>
    );
  };

  const handleExport = () => {
    try {
      const headers = columns.map((col) => `"${decodeHtmlEntities(col.title).replace(/"/g, '""')}"`);

      const csvContent = [
        headers.join(","),
        ...tableData.map((row) =>
          columns
            .map((col) => {
              let value = row[col.data];

              // Special handling for file uploads
              if (col.type === 'file-upload' && value && value !== '-') {
                value = `File: ${value}`; // Include the URL in CSV
              }

              // Value is already decoded in the table data, just handle CSV formatting
              if (typeof value === "object" && value !== null) {
                if (Array.isArray(value)) {
                  value = value.join(", ");
                } else {
                  value = JSON.stringify(value);
                }
              }

              if (value === null || value === undefined) {
                value = "";
              }

              return `"${String(value).replace(/"/g, '""')}"`;
            })
            .join(",")
        ),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `survey_responses_${surveyId}_${format(new Date(), "yyyy-MM-dd")}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting data:", error);
    }
  };

  const handleRetry = () => {
    dispatch(fetchSurveyResponses(surveyId));
  };

  const renderSkeleton = () => (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" spacing={2} justifyContent="space-between" mb={3}>
        <Skeleton
          variant="rectangular"
          width={120}
          height={40}
          sx={{
            borderRadius: 1,
            transform: "none",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
        <Skeleton
          variant="rectangular"
          width={200}
          height={40}
          sx={{
            borderRadius: 1,
            transform: "none",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
      </Stack>

      <Card
        sx={{ boxShadow: "none", border: "1px solid", borderColor: "divider" }}
      >
        <CardContent>
          <Box sx={{ display: "flex", gap: 2, mb: 3, px: 1 }}>
            {[50, 150, 200, 200, 200].map((width, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                width={width}
                height={44}
                sx={{
                  borderRadius: 1,
                  transform: "none",
                  animation: "pulse 1.5s ease-in-out infinite",
                  backgroundColor: "rgba(53, 140, 124, 0.08)",
                }}
              />
            ))}
          </Box>

          {[...Array(7)].map((_, rowIndex) => (
            <Box
              key={rowIndex}
              sx={{
                display: "flex",
                gap: 2,
                p: 1,
                borderBottom: "1px solid",
                borderColor: "divider",
                "&:last-child": {
                  borderBottom: "none",
                },
              }}
            >
              {[50, 150, 200, 200, 200].map((width, colIndex) => (
                <Skeleton
                  key={colIndex}
                  variant="rectangular"
                  width={width}
                  height={32}
                  sx={{
                    borderRadius: 1,
                    transform: "none",
                    animation: "pulse 1.5s ease-in-out infinite",
                    backgroundColor: "rgba(0, 0, 0, 0.04)",
                  }}
                />
              ))}
            </Box>
          ))}
        </CardContent>
      </Card>
    </Box>
  );

  const renderEmptyState = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: 10,
          px: 2,
        }}
      >
        <NoDataIllustration 
          sx={{ 
            fontSize: 120,
            color: 'rgba(17, 153, 142, 0.2)',
            mb: 3
          }}
        />
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#11998e',
            fontWeight: 500,
            mb: 1 
          }}
        >
          No Responses Yet
        </Typography>
      </Box>
    );
  };

  const renderHeader = () => {
    if (!tableData?.length) return null;
    
    return (
      <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        gap: 2,
        flexWrap: 'wrap'
      }}>
        <Button
          variant="outlined"
          startIcon={<FileDownloadIcon />}
          onClick={handleExport}
          sx={{
            borderRadius: 2,
            borderColor: '#11998e',
            color: '#11998e',
            '&:hover': {
              borderColor: '#0d7a6b',
              backgroundColor: 'rgba(17, 153, 142, 0.04)'
            }
          }}
          disabled={!tableData?.length}
        >
          Export CSV
        </Button>
        
        <TextField
          size="small"
          placeholder="Search responses..."
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: '#11998e' }} />
              </InputAdornment>
            ),
          }}
          sx={{
            minWidth: '280px',
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'rgba(17, 153, 142, 0.04)',
              '& fieldset': {
                borderColor: 'rgba(17, 153, 142, 0.2)'
              },
              '&:hover fieldset': {
                borderColor: '#11998e'
              },
              '&.Mui-focused fieldset': {
                borderColor: '#11998e',
                borderWidth: '2px'
              }
            },
            '& .MuiInputBase-input::placeholder': {
              color: 'rgba(17, 153, 142, 0.7)',
              opacity: 1
            }
          }}
        />
      </Box>
    );
  };

  const getQuestionIcon = (type) => {
    if (!type) return <TextFields sx={{ color: '#11998e' }} />;
  
    switch (type.toLowerCase()) {
      case 'dropdown':
        return <ArrowDropDownIcon sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'short-answer':
        return <TextFields sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'long-answer':
        return <Subject sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'multiple-choice':
        return <RadioButtonChecked sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'checkboxes':
        return <CheckBox sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'email':
        return <Email sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'number':
        return <Numbers sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'date':
        return <CalendarMonth sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'file-upload':
        return <Upload sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'rating':
        return <Star sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'phone':
        return <Phone sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'matrix':
        return <TableChart sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'likert-scale':
        return <CompareArrows sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'nps':
        return <Looks3 sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'ranking':
        return <Sort sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'datetime':
        return <EventNote sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'time':
        return <AccessTime sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'website':
        return <Language sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'address':
        return <LocationOn sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'image-choice':
        return <ImageIcon sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'range-scale':
        return <LinearScaleIcon sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'image-question':
        return <ImageOutlined sx={{ color: '#11998e', fontSize: 20 }} />;
      case 'range-question':
        return <LinearScale sx={{ color: '#11998e', fontSize: 20 }} />;
      default:
        return <TextFields sx={{ color: '#11998e', fontSize: 20 }} />;
    }
  };

  const renderCell = (type) => (rowData, column) => {
    const value = rowData[column.field];

    switch (type?.toLowerCase()) {
      case "datetime":
        return value ? format(new Date(value), "MMM d, yyyy HH:mm") : "";
      case "rating":
      case "likert-scale":
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Typography>{value}</Typography>
          </Box>
        );
      case "website":
        return value ? (
          <Link href={value} target="_blank" rel="noopener noreferrer">
            {value}
          </Link>
        ) : '-';
      case "long-answer":
        return (
          <Typography
            sx={{
              maxWidth: "300px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {value}
          </Typography>
        );
      case "file-upload":
        return   (
          <FilePreview fileUrl={value} />
        );
      // case 'image-choice':
      //   try {
      //     // Parse the JSON string to get array of URLs
      //     const imageUrls = typeof value === 'string' ? JSON.parse(value) : value;
          
      //     return imageUrls && imageUrls.length > 0 ? (
      //         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      //             {imageUrls.map((url, idx) => (
      //                 <Box key={idx} sx={{ display: 'flex', alignItems: 'center' }}>
      //                     <Box
      //                         component="img"
      //                         src={url}
      //                         alt={`Selected option ${idx + 1}`}
      //                         sx={{
      //                             width: 40,
      //                             height: 40,
      //                             objectFit: 'cover',
      //                             borderRadius: 1,
      //                             border: '1px solid',
      //                             borderColor: 'divider'
      //                         }}
      //                     />
      //                     <Typography 
      //                         variant="caption" 
      //                         sx={{ 
      //                             ml: 1,
      //                             color: 'text.secondary',
      //                             display: '-webkit-box',
      //                             WebkitLineClamp: 2,
      //                             WebkitBoxOrient: 'vertical',
      //                             overflow: 'hidden'
      //                         }}
      //                     >
      //                         {url.split('/').pop()}
      //                     </Typography>
      //                 </Box>
      //             ))}
      //         </Box>
      //     ) : '-';
      // } catch (error) {
      //     console.error('Error parsing image-choice answer:', error);
      //     return '-';
      // }
      case 'image-choice':
        try {
            // Parse the answer if it's a string
            const parsedValue = typeof value === 'string' ? JSON.parse(value) : value;
            if (!parsedValue) return '-';
    
            // Handle array of URLs (format 2)
            if (Array.isArray(parsedValue)) {
                return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                        {parsedValue.map((url, idx) => (
                            <Box 
                                key={idx} 
                                sx={{ 
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    borderRadius: 1,
                                    overflow: 'hidden',
                                    width: 'fit-content'
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'start', gap: 1,  }}>
                                    <Box
                                        component="img"
                                        src={url}
                                        alt={`Option ${idx + 1}`}
                                        sx={{
                                            width: 40,
                                            height: 40,
                                            objectFit: 'cover',
                                            borderRadius: 1
                                        }}
                                    />
                                </Box>
                            </Box>
                        ))}
                    </Box>
                );
            }
    
            // Handle object format (format 1)
            const imageChoices = Array.isArray(parsedValue) ? parsedValue : [parsedValue];
            
            return (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {imageChoices.map((choice, idx) => (
                        <Box 
                            key={idx} 
                            sx={{ 
                                border: '1px solid',
                                borderColor: 'divider',
                                borderRadius: 1,
                                overflow: 'hidden',
                                width: 'fit-content'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1 }}>
                                <Box
                                    component="img"
                                    src={choice.imageUrl}
                                    alt={choice.label || `Option ${idx + 1}`}
                                    sx={{
                                        width: 40,
                                        height: 40,
                                        objectFit: 'cover',
                                        borderRadius: 1
                                    }}
                                />
                                <Box sx={{ flex: 1 }}>
                                    {choice.label && (
                                        <Typography 
                                            variant="body2" 
                                            sx={{ fontWeight: 500 }}
                                        >
                                            {choice.label}
                                        </Typography>
                                    )}
                                    {choice.showDescription && choice.description && (
                                        <Typography 
                                            variant="caption" 
                                            sx={{ 
                                                color: 'text.secondary',
                                                display: 'block',
                                                mt: 0.5
                                            }}
                                        >
                                            {choice.description}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
            );
        } catch (error) {
            console.error('Error parsing image-choice answer:', error);
            return '-';
        }
      case 'range-scale':
        return value ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LinearScaleIcon sx={{ color: '#11998e', fontSize: 16 }} />
            <Typography>{value}</Typography>
          </Box>
        ) : '-';
      case 'image-question':
        return value ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box 
              component="img"
              src={value}
              sx={{
                width: 40,
                height: 40,
                borderRadius: 1,
                objectFit: 'cover'
              }}
            />
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {value.split('/').pop()}
            </Typography>
          </Box>
        ) : '-';
      case 'range-question':
        return value ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LinearScale sx={{ color: '#11998e', fontSize: 20 }} />
            <Typography>{value}</Typography>
          </Box>
        ) : '-';
      case "location":
      case "address":
        if (!value || value === "-") return "-";
        return (
          <Typography sx={{
            maxWidth: "100%",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            lineHeight: 1.5,
            width: "100%"
          }}>
            {value}
          </Typography>
        );
      default:
        return value || '-';
    }
  };

  // Add new function to render the expanded content
  const rowExpansionTemplate = (data) => {
    return renderExpandedRow(data);
  };

  const zoomButtonTemplate = (rowData) => {
    return (
      <IconButton 
        size="small" 
        onClick={(e) => {
          e.stopPropagation();
          handleOpenModal(rowData);
        }}
        sx={{ 
          color: '#358c7c',
          '&:hover': {
            transform: 'scale(1.2)',
            color: '#11998e'
          }
        }}
        className="zoom-button"
      >
        <ZoomOutMapIcon fontSize="small" />
      </IconButton>
    );
  };
  // Add this function to render the modal content
  // Update the renderResponseModal function
  const toggleAnswer = (questionId) => {
    setExpandedAnswers(prev => ({
      ...prev,
      [questionId]: !prev[questionId]
    }));
  };
  const renderResponseModal = () => {
    if (!selectedResponse) return null;
    
    return (
      <Dialog
        open={modalOpen}
        onClose={handleCloseModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          className: "response-detail-modal",
          elevation: 3
        }}
      >
        <Box 
          sx={{ 
            p: 1.5,
            bgcolor: '#f8f9fa',
            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
              sx={{
                width: 28,
                height: 28,
                bgcolor: 'rgba(17, 153, 142, 0.12)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <EventNote sx={{ color: '#11998e', fontSize: 16 }} />
            </Box>
            <Stack spacing={0.5}>
              <Typography 
                variant="h6" 
                sx={{ 
                  color: '#11998e',
                  fontSize: '1rem',
                  fontWeight: 500,
                  lineHeight: 1
                }}
              >
                Response Details
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: 'text.secondary',
                  fontSize: '0.875rem'
                }}
              >
                Respondent: {selectedResponse.respondent_email}
              </Typography>
            </Stack>
          </Box>

          <Stack direction="row" spacing={2} alignItems="center">
            <Typography 
              variant="body2" 
              sx={{ color: 'text.secondary' }}
            >
              Submitted: {selectedResponse.created_at}
            </Typography>
            <IconButton
              onClick={handleCloseModal}
              size="small"
              sx={{ 
                color: 'rgba(0, 0, 0, 0.54)',
                padding: 0.5,
                '&:hover': {
                  bgcolor: 'rgba(17, 153, 142, 0.08)'
                }
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Box>

        <DialogContent 
          sx={{ 
            p: 3,
            ['& .MuiGrid-root']: {
              maxWidth: '100%'
            }
          }}
        >
          <Grid container spacing={3}>
            {questions.map((question) => {
              const answer = selectedResponse[question.id] || '-';
              const isExpanded = expandedAnswers[question.id];
              
              return (
                <Grid item xs={12} key={question.id} className="response-detail-question">
                  <Paper 
                    elevation={0} 
                    sx={{ 
                      p: 2.5,
                      border: '1px solid',
                      borderColor: 'rgba(0, 0, 0, 0.1)',
                      borderRadius: 2,
                      '&:hover': {
                        borderColor: '#11998e',
                        backgroundColor: 'rgba(17, 153, 142, 0.02)'
                      }
                    }}
                  >
                    <Stack spacing={2}>
                      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                        <Box
                          sx={{
                            backgroundColor: 'rgba(17, 153, 142, 0.12)',
                            borderRadius: '12px',
                            p: 1.2,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            alignSelf: { xs: 'center', sm: 'center' }, // Center on mobile

                          }}
                        >
                          {getQuestionIcon(question.question_type)}
                        </Box>
                        <Typography 
                          variant="subtitle1" 
                          sx={{ 
                            fontWeight: 500,
                            color: '#0C6558',
                            flex: 1
                          }}
                        >
                          {decodeHtmlEntities(question.question_text)}
                        </Typography>
                      </Box>
                      <Box 
                        onClick={() => toggleAnswer(question.id)}
                        sx={{ 
                          pl: 5.5,
                          borderLeft: '3px solid rgba(17, 153, 142, 0.15)',
                          ml: 1,
                          position: 'relative',
                          cursor: {xs: 'pointer', md: 'default'}
                        }}
                      >
                        <Typography 
                          variant="body1" 
                          sx={{ 
                            whiteSpace: 'pre-wrap', 
                            wordBreak: 'break-word',
                            color: 'text.primary',
                            lineHeight: 1.6,
                            display: {
                              xs: isExpanded ? 'block' : '-webkit-box',
                              md: 'block'
                            },
                            WebkitLineClamp: {
                              xs: isExpanded ? 'unset' : 3,
                              md: 'unset'
                            },
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            transition: 'all 0.3s ease'
                          }}
                        >
                          {question.question_type === 'image-choice' ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                              {(() => {
                                try {
                                  const imageData = typeof answer === 'string' ? JSON.parse(answer) : answer;
                                  
                                  // Handle array format
                                  if (Array.isArray(imageData)) {
                                    return imageData.map((url, idx) => (
                                      <Box key={idx} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                        <Link
                                          href={url}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          sx={{
                                            color: '#11998e',
                                            textDecoration: 'none',
                                            '&:hover': {
                                              textDecoration: 'underline'
                                            }
                                          }}
                                        >
                                          {url.split('/').pop()}
                                        </Link>
                                      </Box>
                                    ));
                                  }
                                  
                                  // Handle object format
                                  return (
                                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
                                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                        <Link
                                          href={imageData.imageUrl}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          sx={{
                                            color: '#11998e',
                                            textDecoration: 'none',
                                            '&:hover': {
                                              textDecoration: 'underline'
                                            }
                                          }}
                                        >
                                          {imageData.imageUrl.split('/').pop()}
                                        </Link>
                                        {imageData.label && (
                                          <Typography 
                                            variant="body2" 
                                            sx={{ 
                                              color: 'text.secondary',
                                              mt: 0.5 
                                            }}
                                          >
                                            <Box component="span" sx={{ fontWeight: 500 }}>Label: </Box>
                                            {imageData.label}
                                          </Typography>
                                        )}
                                        {imageData.showDescription && imageData.description && (
                                          <Typography 
                                            variant="body2" 
                                            sx={{ 
                                              color: 'text.secondary',
                                              mt: 0.5 
                                            }}
                                          >
                                            <Box component="span" sx={{ fontWeight: 500 }}>Description: </Box>
                                            {imageData.description}
                                          </Typography>
                                        )}
                                      </Box>
                                    </Box>
                                  );
                                } catch (error) {
                                  console.error('Error parsing image choice data:', error);
                                  return String(answer);
                                }
                              })()}
                            </Box>
                          ) : question.question_type === 'file-upload' ? (
                            <Link 
                              href={answer} 
                              target="_blank"
                              rel="noopener noreferrer"
                              sx={{
                                color: '#11998e',
                                textDecoration: 'none',
                                '&:hover': {
                                  textDecoration: 'underline'
                                }
                              }}
                            >
                              {answer.split('/').pop()} {/* Show only filename */}
                            </Link>
                          ) : (
                            // Regular answer display
                            answer
                          )}
                        </Typography>
                        {answer.length > 150 && (
                          <Button
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleAnswer(question.id);
                            }}
                            sx={{ 
                              display: { xs: 'flex', md: 'none' },
                              mt: 1,
                              color: '#11998e',
                              '&:hover': {
                                backgroundColor: 'rgba(17, 153, 142, 0.08)'
                              }
                            }}
                          >
                            {isExpanded ? 'Show Less' : 'Read More'}
                          </Button>
                        )}
                      </Box>
                    </Stack>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
      </Dialog>
    );
  };
  
  return (
    <Box sx={{ p: 2 }}>
      <style>{customStyles}</style>
      {loading ? (
        renderSkeleton()
      ) : error ? (
        <Box p={3}>
          <Typography color="error" gutterBottom>
            {error}
          </Typography>
          <Button variant="outlined" color="primary" onClick={handleRetry}>
            Retry
          </Button>
        </Box>
      ) : (
        <Card
          sx={{
            boxShadow: "none",
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 2,
          }}
        >
          <CardContent>
            <DataTable
              value={tableData}
              paginator={!!tableData?.length}
              rows={10}
              rowsPerPageOptions={[10, 25, 50]}
              globalFilter={globalFilter}
              header={renderHeader()}
              sortMode="multiple"
              removableSort
              resizableColumns
              columnResizeMode="expand"
              scrollable
              scrollHeight="600px"
              className="p-datatable-sm"
              emptyMessage={renderEmptyState()}
              stripedRows={!!tableData?.length}
              showGridlines={!!tableData?.length}
              responsiveLayout="scroll"
              dataKey="rowNumber"
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="{first} to {last}"
            >
              {/* Zoom button column */}
              <Column 
                body={zoomButtonTemplate} 
                style={{ width: '40px' }}
                className="zoom-button-column"
                exportable={false}
              />
              <Column
                header="No."
                body={(rowData, options) => options.rowIndex + 1}
                style={{ 
                  width: "50px", 
                  textAlign: "center",
                  backgroundColor: '#fff'
                }}
              />
              <Column
                field="created_at"
                header="Submitted At"
                sortable
                style={{ minWidth: "150px" }}
              />
              {columns.slice(2).map((col) => (
                <Column
                  key={col.data}
                  field={col.data}
                  header={() => (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {getQuestionIcon(col.type)}
                    <Typography>{col.title}</Typography>
                  </Box>
                )}
                  sortable
                  body={renderCell(col.type)}
                  style={{
                    minWidth: col.type === "long-answer" || col.type === "location" || col.type === "address" 
                      ? "300px" 
                      : "200px",
                    width: "auto"
                  }}
                  resizeable
                />
              ))}
            </DataTable>
          </CardContent>
        </Card>
      )}
      {/* Add the modal at the end of your render function */}
      {renderResponseModal()}
    </Box>
  );
};

export default Results;
